import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { TenantComponent } from './components/tenant/tenant.component';
//import { PTenantComponent } from './components/ptenant/ptenant.component';

import { HttpClientModule } from '@angular/common/http';

// import the Angular Captcha Module 
import { BotDetectCaptchaModule } from 'angular-captcha'; 
import { ReCaptchaModule } from 'angular-recaptcha3';

// Forms module
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { PricingComponent } from './components/pricing/pricing.component';
import { ProductComponent } from './components/product/product.component';
import { ContactComponent } from './components/contact/contact.component';
import { ClientsComponent } from './components/clients/clients.component';

@NgModule({
	declarations: [
		AppComponent,
		HeaderComponent,
		FooterComponent,
		HomeComponent,
		TenantComponent,
		//PTenantComponent,
		PricingComponent,
		ProductComponent,
		ContactComponent,
		ClientsComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		BotDetectCaptchaModule,
		ReCaptchaModule.forRoot({
			invisible: {
				sitekey: '6LdHqsQdAAAAANKkSvJmHs-bmnfoJHdgjqQbC-hE', 
			},
			normal: {
				sitekey: '6LdHqsQdAAAAANKkSvJmHs-bmnfoJHdgjqQbC-hE', 
			},
			language: 'en'
		}),
	],
	providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
	bootstrap: [AppComponent]
})
export class AppModule { }
